@if (
  {
    row: columnData | async,
    adata: additionData | async,
  };
  as $
) {
  @if ($.row[$.adata.keyname] !== '0001-01-01T00:00:00') {
    <span>
      <span>{{
        dateToLocalTimeZone($.row[$.adata.keyname]) | date: $.adata.format
      }}</span>
    </span>
  } @else {
    -
  }
}
